import { __decorate } from "tslib";
import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { EventbusType } from '@movecloser/front-core';
import { Inject } from '@plugin/inversify';
import { SiteServiceType } from '@service/site';
import { logoRegistry } from '@component/BottomBar/BottomBar.config';
let BottomBar = class BottomBar extends Vue {
    /**
     * Determines whether the current page is homepage.
     */
    get isHomepage() {
        return this.$route.path === '/';
    }
    /**
     * Logotype SVG file to render.
     */
    get logo() {
        var _a;
        return (_a = logoRegistry[this.site.domain]) !== null && _a !== void 0 ? _a : '';
    }
    /**
     * Return current Site.
     */
    get site() {
        return this.siteService.getActiveSite();
    }
    toggleMenu() {
        this.eventBus.emit('ui:sidebar.toggle');
    }
    setBottomBarHeight() {
        if (this.containerRef) {
            document.documentElement.style.setProperty('--bottombar-height', this.containerRef.clientHeight + 'px');
        }
    }
};
__decorate([
    Prop({
        type: Array,
        required: false
    })
], BottomBar.prototype, "links", void 0);
__decorate([
    Ref('container')
], BottomBar.prototype, "containerRef", void 0);
__decorate([
    Inject(EventbusType)
], BottomBar.prototype, "eventBus", void 0);
__decorate([
    Inject(SiteServiceType)
], BottomBar.prototype, "siteService", void 0);
BottomBar = __decorate([
    Component({
        name: 'BottomBar',
        components: {},
        mounted() {
            this.setBottomBarHeight();
        }
    })
], BottomBar);
export { BottomBar };
export default BottomBar;
